import React from 'react'
import { Route } from 'react-router-dom'
import Home from '../home'
import Guide from '../guide'

const App = () => (
  <div>
    <main>
      <Route exact path="/" component={Home} />
      <Route exact path="/guide" component={Guide} />
    </main>
  </div>
)

export default App
